import { dispatch, State, useSelector } from '@ui-complex/react-state';

export const dashboardState = {
  callHistory: {
    visible: false
  } as {
    visible: boolean;
    props?: {
      id?: number;
      name: string;
      date?: [string, string];
      employeeIds?: number[];
      pipeIds?: number[];
      statuses?: string[];
      talkTimeStart?: string;
      talkTimeFinish?: string;
      groupBy?: string;
    };
  }
};

export const useDashboardSelector = <T, _>(selector: (state: typeof dashboardState) => T) =>
  useSelector(dashboardState, selector);

export const dashboardDispatch = <T, _>(selector: (state: typeof dashboardState) => T) =>
  dispatch(dashboardState, selector);

export const DashboardState = <T, _>({
  children,
  selector
}: {
  children: (props: T) => React.ReactElement;
  selector: (state: typeof dashboardState) => T;
}) => <State state={dashboardState} selector={selector} children={children} />;
